import { Service } from '@Types/app';

const IS_UIC =
  localStorage.getItem('uic_companyGUID') !== null ||
  localStorage.getItem('uic-token') !== null;

export const IS_UAE = window.DEPLOY_REGION === 'uaenorth';
export const IS_MEA = window.DEPLOY_REGION === 'uae-north';
export const IS_JP = window.DEPLOY_REGION === 'jp-east';

export const MailServices = [
  Service.Exchange,
  Service.ExchangeInline,
  Service.Gmail,
  Service.GmailInline,
];

export const InlineServices = [Service.ExchangeInline, Service.GmailInline];

export const PRODUCT_NAME = IS_UIC
  ? 'Cloud Email and Collaboration Protection'
  : 'Cloud App Security';
